import { BrandsTable, CategoryTable, ProductsTable } from "@/components";

export const tabsTrigger = [
  { value: "products", label: "Products" },
  { value: "categories", label: "Categories" },
  { value: "brands", label: "Brands" },
];

export const tabsContent = [
  {
    value: "products",
    element: (
      <>
        <ProductsTable />
      </>
    ),
  },
  {
    value: "categories",
    element: (
      <>
        <CategoryTable />
      </>
    ),
  },
  {
    value: "brands",
    element: (
      <>
        <BrandsTable />
      </>
    ),
  },
];
